module.exports = __webpack_public_path__ + "static/media/footprint.1714b6be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/footprint.svg
// module id = 277
// module chunks = 0